//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { WestfieldSuiteLargeSVG } from './svg'

interface WestfieldSuiteLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const WestfieldSuiteLargeIcon: React.FC<WestfieldSuiteLargeIconProps> = forwardRef<
  WestfieldSuiteLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={WestfieldSuiteLargeSVG} sx={sx} />
))
